import { render } from "./Doctor.vue?vue&type=template&id=2f4f1f5c&ts=true"
import script from "./Doctor.vue?vue&type=script&lang=ts"
export * from "./Doctor.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/poct.nikted.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__